import { useQuery } from "@tanstack/react-query";
import { PageModuleData } from "entities/pages/types";
import { queryClient } from "shared/api/queryClient";
import { getModulesListByBrandSetting } from "../api/getModulesListByBrandSetting";

const getQueryKey = (brandId: string, settingId: string): any => {
  return ["settingModules", { brandId, settingId }];
};

export const useModuleListByBrandSettingQuery = (
  brandId: string,
  settingId: string,
) => {
  return useQuery({
    queryKey: getQueryKey(brandId, settingId),
    queryFn: () => getModulesListByBrandSetting(brandId, settingId),
  });
};

export const getModuleListByBranchSettingQueryData = (
  brandId: string,
  settingId: string,
) => {
  return queryClient.getQueryData<PageModuleData[]>(
    getQueryKey(brandId, settingId),
  );
};

export const setModuleListByBranchSettingQueryData = (
  brandId: string,
  settingId: string,
  data: PageModuleData[],
) => {
  queryClient.setQueryData(getQueryKey(brandId, settingId), data);
};

export const invalidateModuleListByBrandSettingQuery = async (
  brandId: string,
  settingId: string,
) => {
  await queryClient.invalidateQueries({
    queryKey: getQueryKey(brandId, settingId),
  });
};
